export const environment = {
  production: true,
  //SOCKET_ENDPOINT: 'http://127.0.0.1:31415'
  SOCKET_ENDPOINT: 'https://chat.movin.cloud'
};
